module.exports = __webpack_public_path__ + "static/high-wheelers-masonic-ba0126656ece88338babd323a465b5ca.jpg";